import React, { useState } from "react";
import handshake from "assets/img/talk.svg";
import {
    NewSection as Section,
    ContactContainer,
    Form,
    TalkIcon,
    Input,
    Field,
    Submit,
    Message,
    AlertMsg,
} from "./style";
import { Title } from "components/shared";

const formDataToJson = (formData) => {
    const entries = formData.entries();

    const dataObj = Array.from(entries).reduce((data, [key, value]) => {
        data[key] = value;
        if (key === "email") {
            data._replyTo = value;
        }
        return data;
    }, {});

    return JSON.stringify(dataObj);
};

export default function Contact() {
    const [formStatus, setFormStatus] = useState({
        isDisplayed: false,
        message: "",
        bg: "lime",
    });

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const form = e.target;
            const data = new FormData(form);

            const res = await fetch(form.action, {
                method: form.method,
                body: formDataToJson(data),
                headers: {
                    "Content-Type": "application/json",
                },
            });

            form.reset();

            if (res.status === 200) {
                setFormStatus({
                    isDisplayed: true,
                    message: "Successfully Sent!",
                    bg: "lime",
                });
            }
        } catch (err) {
            setFormStatus({
                isDisplayed: true,
                message: "Try Again",
                bg: "crimson",
            });
        } finally {
            setTimeout(
                () =>
                    setFormStatus({
                        isDisplayed: false,
                        message: "",
                        bg: "lime",
                    }),
                2000
            );
        }
    };

    return (
        <Section id="contact">
            <Title>Wanna Work with me?</Title>
            <ContactContainer>
                <TalkIcon src={handshake} alt="Agreement Illustration" loading="lazy"/>
                <Form
                    action="https://formspree.io/maylnwvl"
                    method="POST"
                    onSubmit={handleSubmit}
                >
                    <Field>
                        <label htmlFor="name">Full Name</label>
                        <Input
                            type="text"
                            name="name"
                            id="name"
                            placeholder="John Doe"
                            required
                        />
                    </Field>
                    <Field>
                        <label htmlFor="email">Email</label>
                        <Input
                            type="email"
                            name="email"
                            id="email"
                            placeholder="youremail@email.com"
                            required
                        />
                    </Field>
                    <Field>
                        <label htmlFor="message">Message</label>
                        <Message
                            as="textarea"
                            type="email"
                            name="message"
                            id="message"
                            placeholder="Say Hello!"
                            required
                        />
                    </Field>
                    <Submit as="button">Submit</Submit>
                </Form>
            </ContactContainer>
            <AlertMsg bg={formStatus.bg} isDisplayed={formStatus.isDisplayed}>
                {formStatus.message}
            </AlertMsg>
        </Section>
    );
}
